import React, { useState, useEffect } from 'react'
import Icon from '../Icon'
import {
  SocialMediaContainer,
  SocialMediaListContainer,
  SocialMediaList,
} from './style'
import { H3 } from '../Globals'
import { renderShareUrl, generateRandomKey } from '@utils'

const SocialMedia = ({
  title,
  displayShare = false,
  hashtags,
  platforms,
  margin,
  printer = true,
  ...otherProps
}) => {
  const [location, setLocation] = useState(null)
  const [, setPrintPage] = useState(null)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setLocation(window.location.href)
      setPrintPage(() => () => window.print())
    }
  }, [])

  const socialPlatforms = platforms || ['linkedIn', 'twitter', 'facebook']
  return (
    <SocialMediaContainer margin={margin} {...otherProps}>
      <SocialMediaListContainer>
        {displayShare && (
          <H3 color="gray" marginRight={20}>
            Share
          </H3>
        )}
        {socialPlatforms.map((platform, i) => (
          <SocialMediaList
            key={generateRandomKey()}
            borderRight={i === socialPlatforms.length - 1 && !printer && 'none'}
          >
            <a
              href={renderShareUrl(platform, title, location)}
              rel="noreferrer"
              target="_blank"
            >
              <Icon
                active
                fill="gray"
                glyph={platform}
                height={28}
                width={26}
              />
            </a>
          </SocialMediaList>
        ))}
      </SocialMediaListContainer>
    </SocialMediaContainer>
  )
}

export default SocialMedia
